module.exports = __webpack_public_path__ + "img/POS.9d780678.png";